import http, { url } from '../../http'

const API_URL = "preventionbrigade"

class preventionbrigadeAPI {

  async save(preventionbrigade) {
    const response = await http(`${API_URL}/save`, 'POST', preventionbrigade)
    return response
  }
 
  async getAllBrigade() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getAllIBrigadeCompany(id,  page, search) {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}` , 'POST')
    return response
  } 
 
  async getBrigade(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateBrigade(id, brigade) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', brigade)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new preventionbrigadeAPI()